module.exports = __webpack_public_path__ + "img/innove.d6fc8b76.jpg";